import { render, staticRenderFns } from "./ProfessionalTools.vue?vue&type=template&id=9ae795c2"
import script from "./ProfessionalTools.vue?vue&type=script&lang=js"
export * from "./ProfessionalTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports